/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Rename_SavedInputs */

const en_us2_plan_rename_saved = /** @type {(inputs: Plan_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name updated`)
};

const pt_br2_plan_rename_saved = /** @type {(inputs: Plan_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome atualizado`)
};

const es_419_plan_rename_saved = /** @type {(inputs: Plan_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre actualizado`)
};

const pt_pt2_plan_rename_saved = /** @type {(inputs: Plan_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome atualizado`)
};

const fr_fr2_plan_rename_saved = /** @type {(inputs: Plan_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom mis à jour`)
};

const de_de2_plan_rename_saved = /** @type {(inputs: Plan_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name aktualisiert`)
};

const it_it2_plan_rename_saved = /** @type {(inputs: Plan_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome aggiornato`)
};

/**
* | output |
* | --- |
* | "Name updated" |
*
* @param {Plan_Rename_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_rename_saved = /** @type {((inputs?: Plan_Rename_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Rename_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_rename_saved(inputs)
	if (locale === "es-419") return es_419_plan_rename_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_rename_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_rename_saved(inputs)
	if (locale === "de-DE") return de_de2_plan_rename_saved(inputs)
	if (locale === "it-IT") return it_it2_plan_rename_saved(inputs)
	return en_us2_plan_rename_saved(inputs)
});
export { plan_rename_saved as "plan.rename_saved" }